import React from 'react';
import {
  FormikNumberInput as Input,
  UserMeasurementWeightUnitType,
} from '@front-activerse/common-components';
import { dietSettings } from '../types';
import { useFormikContext } from 'formik';
import { useTranslator } from '@front-activerse/common-components';

export const Weight: React.FC = () => {
  const { t } = useTranslator();
  const { values } = useFormikContext<dietSettings>();

  const weightUnit = values.weightUnit;

  return (
    <>
      <h2 className="mb-xl title-large semi-bold">
        {t('app.goalSettings.currentBodyWeight.headline')}
      </h2>
      <Input
        name="weightValue"
        placeholder="0"
        label=""
        text={
          weightUnit === UserMeasurementWeightUnitType.kg
            ? t('goalSettings.currentBodyWeight.description', { min: 40, max: 250 })
            : t('goalSettings.currentBodyWeight.description', { min: 90, max: 550 })
        }
        unit={weightUnit}
        step={weightUnit === UserMeasurementWeightUnitType.kg ? '0.1' : '1'}
        translateErrMsg={false}
      />
    </>
  );
};

export default Weight;
